import * as _ from 'lodash';

import { IValueViewModel, TagManualInputValues, IFrequency } from '../../models/index';

export function toTagManualInputValues(valueViewModel: IValueViewModel, defaultFreq: IFrequency): TagManualInputValues {
    const retval = new TagManualInputValues();
    retval.guid = valueViewModel.guid;
    retval.name = valueViewModel.name;
    if (valueViewModel) {
        retval.comment = valueViewModel.shortComment;
        retval.unit = valueViewModel.unitName;
        retval.min = valueViewModel.min;
        retval.max = valueViewModel.max;
        retval.frequency = valueViewModel.groupList && valueViewModel.groupList.length
            ? valueViewModel.groupList[0].frequency
            : defaultFreq;
        retval.viewModel = valueViewModel;
    }
    if (!retval.frequency || retval.frequency.interval === 0) {
        retval.frequency = defaultFreq;
    }
    return retval;
}